import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cloneDeep, isEmpty, isEqual, forEach } from 'lodash';
import { getGeoMapTableInfo, resetGeoTableDataWithZeroes, hasGeoDataInTable } from '../../util/geomapUtils';
import { numberWithCommas } from '../../util/CommonUtils';
import * as geoMappingActions from '../../actions/geoMappingActions';

class GeoMapBaseAndTarget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      geoMapBase: props.geoMapBase || [],
      geoMapTarget: props.geoMapTarget || [],
      // baseTargetContainerWidth: null,
      isBaseEditable: false,
      isTargetEditable: false,
      baseLabel: !isEmpty(props.geoMapBase) ? props.geoMapBase[0].originalTitle : '',
      targetLabel: !isEmpty(props.geoMapTarget) ? props.geoMapTarget[0].originalTitle : '',
      isBaseLabelUpdated: (!isEmpty(this.props.originalTitles) &&
      !isEmpty(props.geoMapBase)) &&
      !isEqual(this.props.originalTitles.BaseDataGrid.originalTitle,
        props.geoMapBase[0].originalTitle),
      isTargetLabelUpdated: (!isEmpty(this.props.originalTitles) &&
      !isEmpty(props.geoMapTarget)) &&
      !isEqual(this.props.originalTitles.TargetDataGrid.originalTitle,
        props.geoMapTarget[0].originalTitle),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.geoMapBase !== nextProps.geoMapBase) {
      let isBaseLabelUpdated = false;
      if (!isEmpty(nextProps.originalTitles) && !isEmpty(nextProps.geoMapBase) &&
      !isEmpty(nextProps.originalTitles.BaseDataGrid) &&
        !isEqual(nextProps.originalTitles.BaseDataGrid.originalTitle,
        nextProps.geoMapBase[0].originalTitle)) {
        isBaseLabelUpdated = true;
      } else {
        isBaseLabelUpdated = false;
      }
      this.setState({ geoMapBase: nextProps.geoMapBase || [],
        baseLabel: !isEmpty(nextProps.geoMapBase) ?
        nextProps.geoMapBase[0].originalTitle : '',
        isBaseLabelUpdated });
    }
    if (this.props.geoMapTarget !== nextProps.geoMapTarget) {
      let isTargetLabelUpdated = false;
      if (!isEmpty(nextProps.originalTitles) && !isEmpty(nextProps.geoMapTarget)
       && !isEmpty(nextProps.originalTitles.TargetDataGrid) &&
      !isEqual(nextProps.originalTitles.TargetDataGrid.originalTitle,
        nextProps.geoMapTarget[0].originalTitle)) {
        isTargetLabelUpdated = true;
      } else {
        isTargetLabelUpdated = false;
      }
      this.setState({ geoMapTarget: nextProps.geoMapTarget || [],
        targetLabel: !isEmpty(nextProps.geoMapTarget) ?
        nextProps.geoMapTarget[0].originalTitle : '',
        isTargetLabelUpdated });
    }
  }

  clearSampleWeightedFun = gridName => {
    const { loginResponse, activeAccountId, geoMapTarget,
      geographicsTableApiQueues } = this.props;
    const TargetExpression = [];
    const geographicsTableApiQueuesList = cloneDeep(geographicsTableApiQueues);
    if (gridName === 'BaseDataGrid' && geoMapTarget.length > 0) {
      const targetInfo = this.props.geoMapTarget[0];
      TargetExpression.push(geoMapTarget[0].keyword);
      this.props.geoMappingActions.getUpdatedTargetSampleAndWeight(targetInfo,
      loginResponse.data.uid,
      activeAccountId,
      this.props.geoMapStudy.pn,
      this.props.geoWeightTypes.wt,
      this.props.geoWeightTypes.dv,
      TargetExpression,
      );
    }
    let updatedGeographicsTableApiQueuesList;
    if (gridName === 'TargetDataGrid') {
      forEach(geographicsTableApiQueuesList, (val, key) => {
        updatedGeographicsTableApiQueuesList = {
          ...updatedGeographicsTableApiQueuesList,
          [key]: val.length > 0 ? [] : val,
        };
        return updatedGeographicsTableApiQueuesList;
      });
    }
    this.props.geoMappingActions.clearSampleWeighted(gridName,
      updatedGeographicsTableApiQueuesList).then(() => {
        if (hasGeoDataInTable(this.props.geographicsTableData)) {
          const { geoMapTarget } = this.props;
          if (geoMapTarget.length > 0) {
            this.props.geoMappingActions.resetGeoMapTablesWithZerosAndApis().then(() => {
              const { selectedGeographicsTabIndex, countyCategorySelectedVal,
                zipcodeCategorySelectedVal, geographicsTableApiQueues, geoMapStudy,
                geoMapTarget, geoWeightTypes, loginResponse, activeAccountId } = this.props;
              getGeoMapTableInfo(
                loginResponse,
                activeAccountId,
                geoMapStudy,
                geoWeightTypes,
                geoMapTarget,
                selectedGeographicsTabIndex,
                countyCategorySelectedVal,
                zipcodeCategorySelectedVal,
                geographicsTableApiQueues,
                this.props.geoMappingActions.getGeoghrapicsTableData,
                this.props.geoMappingActions.setGeoghrapicsTableApiCallStatus,
              );
            });
          } else {
            const { geographicsTableData } = this.props;
            const newGeoTableData = resetGeoTableDataWithZeroes(
              geographicsTableData
            );
            this.props.geoMappingActions.resetGeographicsTableDataWithZeros(
              newGeoTableData);
          }
        }
      });
  };

  // handleBaseAndTargetContainerResize = dimensions => {
  //   this.setState({ baseTargetContainerWidth: dimensions.width });
  // };

  handleRowUpdated = (gridType, index) => {
    let isBaseEditable = this.state.isBaseEditable;
    let isTargetEditable = this.state.isTargetEditable;
    let originalT = '';
    let rows = [];
    let updatedT = '';
    let baseLabel = '';
    let targetLabel = '';
    if (gridType === 'BaseDataGrid') {
      updatedT = cloneDeep(this.state.baseLabel).trim();
      rows = cloneDeep(this.props.geoMapBase);
      Object.assign(rows[index], { title: updatedT.toUpperCase() });
      originalT = rows[index].originalTitle;
      updatedT = updatedT || originalT;
      baseLabel = updatedT;
      isBaseEditable = !isBaseEditable;
    } else {
      updatedT = cloneDeep(this.state.targetLabel).trim();
      rows = cloneDeep(this.props.geoMapTarget);
      Object.assign(rows[index], { title: updatedT.toUpperCase() });
      originalT = rows[index].originalTitle;
      updatedT = updatedT || originalT;
      targetLabel = updatedT;
      isTargetEditable = !isTargetEditable;
    }
    if (updatedT.toUpperCase() !== originalT.toUpperCase()) {
      if (updatedT) {
        Object.assign(rows[index], { originalTitle: updatedT.toUpperCase() });
      }
      this.props.geoMappingActions.updateSampleWeighted(
        [...rows],
        gridType,
      );
    }
    this.setState({ isBaseEditable, isTargetEditable, baseLabel, targetLabel });
  }

  handleOnChange = (e, gridType) => {
    const label = e.target.value;
    if (gridType === 'BaseDataGrid') {
      this.setState({ baseLabel: label });
    } else {
      this.setState({ targetLabel: label });
    }
  }

  makeEditable = gridType => {
    if (gridType === 'BaseDataGrid') {
      this.setState(() => ({
        isBaseEditable: true,
        baseLabel: this.props.geoMapBase[0].originalTitle,
      }), () => {
        const input = document.getElementById('base');
        input.select();
        input.focus();
      });
    } else {
      this.setState(() => ({
        isTargetEditable: true,
        targetLabel: this.props.geoMapTarget[0].originalTitle,
      }), () => {
        const input = document.getElementById('target');
        input.select();
        input.focus();
      });
    }
  }

  render() {
    const geoMapBase = cloneDeep(this.state.geoMapBase);
    const geoMapTarget = cloneDeep(this.state.geoMapTarget);
    const { isBaseEditable, isBaseLabelUpdated, baseLabel,
      isTargetEditable, isTargetLabelUpdated, targetLabel } = this.state;
    return (
      <div
        className="expanded large-12 geomap-base-target-tables-wrapper"
        data-test="geomapBaseAndTargetBlock"
      >
        <div
          className=" medium-6 large-6 columns padding-left-0"
          style={{ paddingRight: '10px' }}
        >
          <div className="geomap-grids-header">
            <button
              data-test="removeBases"
              type="button"
              aria-label="remove bases"
              className="clear-btn"
              onClick={() => this.clearSampleWeightedFun('BaseDataGrid')}
              disabled={this.state.geoMapBase.length === 0}
            />
          </div>
          <div className="geomap-base-data-grid">
            <table>
                <tr className="large-12 header-row">
                  <th className="columns first-column">Base</th>
                  <th className="columns">Sample</th>
                  <th className="columns">Weighted</th>
                </tr>
                {geoMapBase.length ? (
                  geoMapBase.map((row, index) => (
                    <tr className="large-12 body-row" key={[row.keyword, index].join('_')}>
                      {isBaseEditable ? (
                        <td className=" medium-6 large-6 columns body-input-column first-column">
                          <input
                            type="text"
                            id="base"
                            value={baseLabel}
                            onChange={e =>
                              this.handleOnChange(e, 'BaseDataGrid')
                            }
                            onBlur={() =>
                              this.handleRowUpdated('BaseDataGrid', index)
                            }
                            onKeyUp={e => {
                              if (e.key === 'Enter') {
                                this.handleRowUpdated('BaseDataGrid', index);
                              }
                            }}
                            className="editable-input"
                            autoComplete="off"
                          />
                        </td>
                      ) : (
                        <td
                          className="columns body-column first-column"
                          title={
                            !isEmpty(geoMapBase) &&
                            geoMapBase[index].originalTitle.toUpperCase()
                          }
                          onDoubleClick={() =>
                            this.makeEditable('BaseDataGrid')
                          }
                        >
                          {!isEmpty(geoMapBase) &&
                            geoMapBase[index].originalTitle.toUpperCase()}
                          <sup>{isBaseLabelUpdated ? '1' : ''}</sup>
                        </td>
                      )}
                      <td className="medium-3 large-3 columns body-column">
                        {!isEmpty(geoMapBase) &&
                          numberWithCommas(geoMapBase[index].sample)}
                      </td>
                      <td className="medium-3 large-3 columns body-column">
                        {!isEmpty(geoMapBase) &&
                          numberWithCommas(geoMapBase[index].weighted)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="large-12 body-row" key={uuid()}>
                    <td className=" medium-6 large-6 columns empty-body first-column">
                      {!isEmpty(geoMapBase) && geoMapBase[0].originalTitle}
                    </td>
                    <td className="medium-3 large-3 columns empty-body">
                      {!isEmpty(geoMapBase) &&
                        numberWithCommas(geoMapBase[0].sample)}
                    </td>
                    <td className="medium-3 large-3 columns empty-body">
                      {!isEmpty(geoMapBase) &&
                        numberWithCommas(geoMapBase[0].weighted)}
                    </td>
                  </tr>
                )}
            </table>
          </div>
        </div>
        <div
          className="medium-6 large-6 columns padding-right-0"
          style={{ paddingLeft: '10px' }}
        >
          <div className="geomap-grids-header">
            <button
              data-test="removeTargets"
              type="button"
              aria-label="remove targets"
              className="clear-btn"
              onClick={() => this.clearSampleWeightedFun('TargetDataGrid')}
              disabled={this.state.geoMapTarget.length === 0}
            />
          </div>
          <div className="geomap-target-data-grid">
            <table>
              <tr className="large-12 header-row">
                <th className="medium-6 large-6 columns first-column">
                  Target
                </th>
                <th className="medium-3 large-3 columns">Sample</th>
                <th className="medium-3 large-3 columns">Weighted</th>
              </tr>
              {geoMapTarget.length ? (
                geoMapTarget.map((row, index) => (
                  <tr className="large-12 body-row" key ={[row.keyword, index].join('_')} >
                    {isTargetEditable ? (
                      <td className=" medium-6 large-6 columns body-input-column first-column">
                        <input
                          type="text"
                          id="target"
                          value={targetLabel}
                          onChange={e =>
                            this.handleOnChange(e, 'TargetDataGrid')
                          }
                          onBlur={() =>
                            this.handleRowUpdated('TargetDataGrid', index)
                          }
                          onKeyUp={e => {
                            if (e.key === 'Enter') {
                              this.handleRowUpdated('TargetDataGrid', index);
                            }
                          }}
                          className="editable-input"
                          autoComplete="off"
                        />
                      </td>
                    ) : (
                      <td
                        className=" medium-6 large-6 columns body-column first-column"
                        title={
                          !isEmpty(geoMapTarget) &&
                          geoMapTarget[index].originalTitle.toUpperCase()
                        }
                        onDoubleClick={() =>
                          this.makeEditable('TargetDataGrid')
                        }
                      >
                        {!isEmpty(geoMapTarget) &&
                          geoMapTarget[index].originalTitle.toUpperCase()}
                        <sup>{isTargetLabelUpdated ? '1' : ''}</sup>
                      </td>
                    )}
                    <td className="medium-3 large-3 columns body-column">
                      {!isEmpty(geoMapTarget) &&
                        numberWithCommas(geoMapTarget[index].sample)}
                    </td>
                    <td className="medium-3 large-3 columns body-column">
                      {!isEmpty(geoMapTarget) &&
                        numberWithCommas(geoMapTarget[index].weighted)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="large-12 body-row" key ={uuid()} >
                  <td className=" medium-6 large-6 columns empty-body first-column">
                    {!isEmpty(geoMapTarget) && geoMapTarget[0].originalTitle}
                  </td>
                  <td className="medium-3 large-3 columns empty-body">
                    {!isEmpty(geoMapTarget) &&
                      numberWithCommas(geoMapTarget[0].sample)}
                  </td>
                  <td className="medium-3 large-3 columns empty-body">
                    {!isEmpty(geoMapTarget) &&
                      numberWithCommas(geoMapTarget[0].weighted)}
                  </td>
                </tr>
              )}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

GeoMapBaseAndTarget.propTypes = {
  geoMappingActions: PropTypes.shape({
    getUpdatedTargetSampleAndWeight: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    resetGeoMapTablesWithZerosAndApis: PropTypes.func,
    getGeoghrapicsTableData: PropTypes.func,
    updateSampleWeighted: PropTypes.func,
    resetGeographicsTableDataWithZeros: PropTypes.func,
    setGeoghrapicsTableApiCallStatus: PropTypes.func,
  }),
  geoMapStudy: PropTypes.instanceOf(Object),
  activeAccountId: PropTypes.number,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
    }),
  }),
  geoMapBase: PropTypes.arrayOf(PropTypes.object),
  geoMapTarget: PropTypes.arrayOf(PropTypes.object),
  geoWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  zipcodeCategorySelectedVal: PropTypes.string,
  countyCategorySelectedVal: PropTypes.string,
  geographicsTableApiQueues: PropTypes.instanceOf(Object),
  selectedGeographicsTabIndex: PropTypes.number,
  originalTitles: PropTypes.instanceOf(Object),
  geographicsTableData: PropTypes.instanceOf(Object),
};

function mapStateToProps(state) {
  return {
    geoMapBase: state.geomap.BaseDataGridData,
    geoMapTarget: state.geomap.TargetDataGridData,
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    geoMapStudy: state.study.geoMapStudy,
    geoWeightTypes: state.study.geoWeightTypes,
    selectedGeographicsTabIndex: state.geomap.selectedGeographicsTabIndex,
    countyCategorySelectedVal: state.geomap.countyCategorySelectedVal,
    zipcodeCategorySelectedVal: state.geomap.zipcodeCategorySelectedVal,
    geographicsTableApiQueues: state.geomap.geographicsTableApiQueues,
    originalTitles: state.geomap.originalTitles,
    geographicsTableData: state.geomap.geographicsTableData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    geoMappingActions: bindActionCreators(geoMappingActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeoMapBaseAndTarget);
